import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FoundationHero = () => {
  const navigate = useNavigate(); // Hook para redireccionar
  const backgroundImages = [
    '/img1.jpg',
    '/img2.jpg',
    '/img3.jpg',
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full h-screen overflow-hidden">
      {/* Carrusel de imágenes */}
      <div
        className="flex transition-transform duration-1000 ease-in-out h-full w-full"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {backgroundImages.map((src, index) => (
          <div
            key={index}
            className="w-full h-full flex-shrink-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${src})` }}
          >
            <div className="w-full h-full bg-gradient-to-br from-green-800 to-yellow-600 opacity-70"></div>
          </div>
        ))}
      </div>

      {/* Contenido al frente */}
      <div className="absolute inset-0 flex items-center justify-center z-10 text-center p-4 md:p-8 text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-6 drop-shadow-lg animate-slide-in-up">
            Fundación Sol Caribe: Preservando Nuestra Herencia
          </h1>
          <p className="text-lg md:text-2xl mb-8 opacity-90 animate-slide-in-up delay-100">
            Unidos por la cultura, la educación y el desarrollo de las comunidades afrocolombianas.
          </p>
          <button
            onClick={() => navigate('/nosotros')}
            className="bg-white text-green-800 px-8 py-3 rounded-full text-xl font-semibold shadow-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 animate-slide-in-up delay-200"
          >
            Conoce Nuestra Historia
          </button>
        </div>
      </div>
    </section>
  );
};

export default FoundationHero;

